export default __webpack_public_path__ + "static/media/btn_character_alignment_bottom.4226e81a.svg";